/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settingsnav_Account1Inputs */

const zh_settingsnav_account1 = /** @type {(inputs: Settingsnav_Account1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`账户`)
};

const en_settingsnav_account1 = /** @type {(inputs: Settingsnav_Account1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account`)
};

const es_settingsnav_account1 = /** @type {(inputs: Settingsnav_Account1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta`)
};

/**
* | output |
* | --- |
* | "Account" |
*
* @param {Settingsnav_Account1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const settingsnav_account1 = /** @type {((inputs?: Settingsnav_Account1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingsnav_Account1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_settingsnav_account1(inputs)
	if (locale === "en") return en_settingsnav_account1(inputs)
	return es_settingsnav_account1(inputs)
});
export { settingsnav_account1 as "settingsNav_account" }